import SmartFeedCardLayout from "%/dynamic-component-editor/options/smart-feed-card-layout";
import SmartFeedLayout from "%/dynamic-component-editor/options/smart-feed-layout";
import SmartFeedSelection from "%/dynamic-component-editor/options/smart-feed-selection";
import HashtagSelector from "%/dynamic-component-editor/options/hashtag-selector";
import StoryTypeSelector from "%/dynamic-component-editor/options/story-type-selector";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";
import EmptyStateComponentId from "%/dynamic-component-editor/options/empty-state-component-id";
import EmptyStateMode, { EMPTY_STATE_MODE_COMPONENT } from "%/dynamic-component-editor/options/empty-state-mode";
import CollectionItemContext from "%/dynamic-component-editor/options/collection-item-context";
import ProductLinkCollection from "%/dynamic-component-editor/options/product-link-collection";
import SmartFeedPagination from "%/dynamic-component-editor/options/smart-feed-pagination";
import SmartFeedPageLimit from "%/dynamic-component-editor/options/smart-feed-page-limit";
import SmartFeedSeeAllDestination from "%/dynamic-component-editor/options/smart-feed-see-all-destination";
import SmartFeedSeeMoreText from "%/dynamic-component-editor/options/smart-feed-see-more-text";
import SmartFeedSeeAllText from "%/dynamic-component-editor/options/smart-feed-see-all-text";
import SmartFeedShowSelection from "%/dynamic-component-editor/options/smart-feed-show-selection";
import SmartFeedSeasonSelection from "%/dynamic-component-editor/options/smart-feed-season-selection";
import SmartFeedSeeMoreAlignment from "%/dynamic-component-editor/options/smart-feed-see-more-alignment";
import SmartFeedColumnMinWidth from "%/dynamic-component-editor/options/smart-feed-column-min-width";
import SmartFeedColumnMaxWidth from "%/dynamic-component-editor/options/smart-feed-column-max-width";
import SmartFeedFiltersToShow from "%/dynamic-component-editor/options/smart-feed-filters-to-show";

export const GlobalFeedElementMixin = {
  elementPanelSettings: {
    displayIcon: "message",
    elementType: "element",
  },
  data() {
    return {
      SmartFeedSelection,
      SmartFeedLayout,
      SmartFeedCardLayout,
      HashtagSelector,
      StoryTypeSelector,
      CollectionItemContext,
      ProductLinkCollection,
      EmptyStateText,
      EmptyStateComponentId,
      EmptyStateMode,
      SmartFeedPagination,
      SmartFeedPageLimit,
      SmartFeedSeeAllDestination,
      SmartFeedSeeMoreText,
      SmartFeedSeeMoreAlignment,
      SmartFeedColumnMinWidth,
      SmartFeedColumnMaxWidth,
      SmartFeedSeeAllText,
      SmartFeedShowSelection,
      SmartFeedSeasonSelection,
      SmartFeedFiltersToShow,
    };
  },
  computed: {
    // Only "component" mode renders a DC; anything else (including feeds saved
    // before the mode option existed) renders EmptyStateText.
    emptyStateComponentId() {
      if (this.getOptionValue(EmptyStateMode) !== EMPTY_STATE_MODE_COMPONENT) {
        return 0;
      }
      const id = Number(this.getOptionValue(EmptyStateComponentId));
      return Number.isFinite(id) && id > 0 ? id : 0;
    },
  },
};
